'use strict';

const shareThis = document.getElementsByClassName( 'social-sharing' );

if ( 0 < shareThis.length ) {
  const script = document.createElement('script');
  script.src = '//platform-api.sharethis.com/js/sharethis.js#property=648bad7b7674a900126112e1&product=inline-share-buttons';
  script.defer = true;
  document.body.appendChild(script);
}